import { useState, useEffect } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

export default function Modal() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(true);
    }, []);

    return (
        <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
            <DialogContent className="relative max-w-md p-0 border-none rounded-lg">
                <IconButton
                    aria-label="close"
                    onClick={() => setIsOpen(false)}
                    style={{ position: "absolute", top: 10, right: 10 }}
                >
                    <CloseIcon />
                </IconButton>
                <img
                    src="/promo.png"
                    alt="Promo"
                    style={{ width: "100%", height: "auto", maxWidth: "90vw" }}
                />
            </DialogContent>
        </Dialog>
    );
}
